import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import modalUtils from '../../../../../../../qti/utils/ModalUtils';
import { t } from '../../../../../../../services/i18nService';

import modalStyles from './DrawingConfirmDeleteModal.scss';

export class DrawingConfirmDeleteModal extends React.Component {
    static propTypes = {
        closeCallback: PropTypes.func.isRequired,
        currentDrawingTarget: PropTypes.object,
        deleteCurrentSelectedDrawing: PropTypes.func,
    };

    closeModal = () => {
        this.props.closeCallback();
    };

    deleteDrawing = () => {
        this.props.closeCallback();
        this.props.deleteCurrentSelectedDrawing();
        this.props.currentDrawingTarget.remove();
    };

    render() {
        return (
            <Modal
                isOpen
                style={modalUtils.confirmDeleteDrawingModalStyles}
                role="dialog"
                tabindex="0"
            >
                <div className={modalStyles.headerContainer}>
                    <div className={modalStyles.drawingConfirmDeleteModalTitle}>
                        {t('essay.drawing.deleteDrawingModal.modalTitle')}
                    </div>
                    <button
                        className={modalStyles.exitButton}
                        onClick={this.closeModal}
                    >
                        <span className="sr-only">{t('general.close')}</span>
                        <i className="fa fa-close fa-3" aria-hidden="true" />
                    </button>
                </div>
                <div className={modalStyles.drawingConfirmDeleteModalDescription}>{t('essay.drawing.deleteDrawingModal.modalDescription')}</div>
                <div>
                    <button
                        onClick={this.deleteDrawing}
                        className={modalStyles.confirmDeleteDrawing}
                    >
                        {t('essay.drawing.deleteDrawingModal.confirmDeleteButton')}
                    </button>
                    <button
                        onClick={this.closeModal}
                        className={modalStyles.cancelDeleteDrawing}
                    >
                        {t('essay.drawing.deleteDrawingModal.cancelDeleteButton')}
                    </button>
                </div>
            </Modal>
        );
    }
}

export default DrawingConfirmDeleteModal;
